import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function queryAll() {
  return request({
    url: URL.finance.softwareConfig.queryAll,
    method: 'get'
  })
}
